import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { AuditLoginModel } from '../../models/userManagementModel/auditlogin.model';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { HomeService } from 'src/app/service/home.service';
import { HomeModel } from 'src/app/models/home/home.model';
import { CommissionSummaryService } from '../../service/commission-summary.service';
import { CommSummaryModel } from '../../models/commissionsummary/commsummary.model';
import { GlobalService } from 'src/app/service/global.service';
import { OnlineCalcService } from 'src/app/service/onlinecalc.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EventBusService } from 'src/app/_shared/event-bus.service';
import { EventData } from 'src/app/_shared/event.class';
import { environment } from 'src/environments/environment';
import { FormControl, NgForm } from '@angular/forms';
import { QuickLinksModel } from 'src/app/models/home/quicklinks.model';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { QuickLinksService } from 'src/app/service/quicklinks.service';
import { ReviewCommissionsService } from 'src/app/service/commission-summary/review-commissions.service';
import { ReviewCommissionsModel } from 'src/app/models/commission-summary/reviewcommissions.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit, OnDestroy {

  commSummaryModel = new CommSummaryModel();
  homeModelDefault = new HomeModel();
  auditLoginModel = new AuditLoginModel(0, null, '', '', '', '');
  showLoading: boolean;
  showMyCommissions: boolean = false;
  showMyCommPlan: boolean = false;
  showAnnouncements: boolean = true;
  subscriptions: Subscription[] = [];
  menuSubMenuData: UserManagementModel[] = [];
  disputeclosedata: HomeModel[] = [];

  loginDisplay = false;
  scempid: any;
  calyear: any;
  chartOptions: any;
  private readonly _destroying$ = new Subject<void>();
  isLoginCheckValidated: boolean = true;

  commplansdata: HomeModel[] = [];
  commplansdataSup: HomeModel[] = [];
  commplansdataRep: HomeModel[] = [];
  commplansdatafilter: HomeModel[] = [];
  calrunidsdata: HomeModel[] = [];
  commrevdata: HomeModel[] = [];
  commrevdatasearch: HomeModel[] = [];
  loadchartdata: [[]];
  ldata: [[]];
  dataPoints: any = [];
  searchCriteriaSet = new Set<string>();
  chartData: any = [];
  chartLabels: any = [];
  chartOption = { responsive: true };
  loginEmployeeId: string;

  complanid: any;
  comm_plan_id: any;
  effective_date: any;
  caltype: any;
  calrunid: any;
  edate: any;
  salesChannel: any;
  imgStr: SafeResourceUrl;
  validFromDate: any;
  validToDate: any;
  scempid1: any;
  

  isHeaderAdmin: boolean = false;

  public quickLinksModel = new QuickLinksModel();
  public myControl = new FormControl();
  public resQuickLinkNames: QuickLinksModel[] = [];
  public quickLinksList: QuickLinksModel[] = [];
  public quickLinksParseList1: QuickLinksModel[] = [];
  public quickLinksParseList2: QuickLinksModel[] = [];
  public filteredQuickLinksOptions: Observable<any[]>;

  currentRoute: string = '';

  constructor(private _sanitizer: DomSanitizer, private router: Router, private notificationService: NotificationService,
    private homeService: HomeService, private commissionSummaryService: CommissionSummaryService, private globalService: GlobalService, private quickLinksService: QuickLinksService,
    private reviewCommissionsService: ReviewCommissionsService
  ) {


    //  Get the current route
    // this.currentRoute = this.router.url;
    // console.log('Current Route:', this.currentRoute);

    // if (this.currentRoute === "/home") {
    //   this.router.navigateByUrl("/home");
    // }


    this.getLinkNames();
    globalService._disableBackButton();

    //console.log("==================== HOME constructor called ================");
  }

  ngOnInit(): void {

    //console.log("==================== HOME ngOnInit called ================");

    this.quickLinksModel.status = "Y";
    this.loginEmployeeId = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');
    this.getCommplansList(this.loginEmployeeId);
    this.getQuickLinksList();
   
  }

  getQuickLinksList() {
    this.quickLinksService.getQuickLinksList().subscribe((data: QuickLinksModel[]) => {
      this.quickLinksList = data;
      this.quickLinksParseList1 = JSON.parse(JSON.stringify(data));
      this.quickLinksParseList2 = JSON.parse(JSON.stringify(data));
      //console.log(this.quickLinksList);

      this.quickLinksList = this.quickLinksList.filter(item => item.status === "Y");
      
      // To enable/disable Quick Links icon
      //console.log(localStorage.getItem('CURRENT_USERROLE_SESSION'));

      if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN") {
        this.isHeaderAdmin = true;
      } else {
        this.isHeaderAdmin = false;
      }

     // console.log("this.isHeaderAdmin = " + this.isHeaderAdmin);


    },
      (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  saveQuickLink(ngForm: NgForm) {
    this.showLoading = true;
    this.quickLinksModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.subscriptions.push(
      this.quickLinksService.saveQuickLink(this.quickLinksModel).subscribe(
        (response: QuickLinksModel) => {
          this.getLinkNames();
          this.getQuickLinksList();
          this.clickButton('new-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Saved/Updated Successfully`);
          ngForm.reset();
          this.showLoading = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.showLoading = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public saveNewTrans(): void {
    this.clickButton('new-save');
  }

  clickButton(buttonId: string): void {
    console.log("called update");
    document.getElementById(buttonId).click();
  }

  getLinkNames() {

    this.filteredQuickLinksOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        return this.getFieldNames(val || '')
      })
    )
  }

  getFieldNames(val: string): Observable<any[]> {

    return this.quickLinksService.getQuickLinkNames()
      .pipe(
        map(response => response.filter(option => {
          this.resQuickLinkNames = response;
          return option.link_name.toLowerCase().indexOf(val.toLowerCase()) === 0
        }))
      )
  }

  public getSelectedLinkNames(desc: string) {
    // console.log("desc = " + desc);

    const filterValue = this.globalService._normalizeValue(desc);
    this.quickLinksParseList2 = this.quickLinksParseList1.filter(item => this.globalService._normalizeValue(item.link_name).startsWith(filterValue));
    this.quickLinksParseList2 = this.quickLinksParseList2.filter((v, i) => this.quickLinksParseList2.findIndex(item => item.link_url == v.link_url) === i);
    if (this.quickLinksParseList2.length > 0) {
      this.quickLinksModel.link_url = this.quickLinksParseList2[0].link_url;
      this.quickLinksModel.status = this.quickLinksParseList2[0].status;
      console.log(this.quickLinksModel.link_url);
      console.log(this.quickLinksModel.status);
    }


    if (desc) {
      return this.resQuickLinkNames?.find(qnames => qnames.link_name === desc).link_name;
    }

  }

  myCommissions() {
    console.log("myCommissions Called");

    this.showMyCommPlan = false;
    if (this.showMyCommissions === true) {
      // console.log("IF Called");
      this.showMyCommissions = false;
      this.showAnnouncements = true;
    } else {
      // console.log("ELSE Called");
      this.showMyCommissions = true;
      this.showAnnouncements = false;
    }

    this.loginEmployeeId = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');
    this.getCommplansList(this.loginEmployeeId);

  }

  myCommPlan() {
    console.log("myCommPlan Called");
    this.showMyCommissions = false;
    if (this.showMyCommPlan === true) {
      this.showMyCommPlan = false;
      this.showAnnouncements = true;
    } else {
      this.showMyCommPlan = true;
      this.showAnnouncements = false;
    }
    this.loginEmployeeId = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');
    this.getCommplansList(this.loginEmployeeId);
  }

  getCommplansList(empid: string) {
    // console.log("getCommplansList Called");
    this.homeModelDefault.scempid = "";
    this.homeModelDefault.calyear = "";
    this.calyear = "";
    this.scempid = "";
    this.commrevdata = [];
    this.homeService.getHomeCommplansList(empid, localStorage.getItem('CURRENT_USERROLE_SESSION'))
      .subscribe((data: any) => {
        this.commplansdata = data;
        //console.log(JSON.stringify(this.commplansdata));
// remove null/undefined rows first
// this.commplansdata = (this.commplansdata ?? []).filter((x: any) => x && x.commissionplan);

// de-dupe safely
// this.commplansdata = this.commplansdata.filter((v: any, i: number, arr: any[]) =>
//   arr.findIndex(item => item && item.commissionplan === v.commissionplan) === i
// );
        this.commplansdata = this.commplansdata.filter((v, i) => this.commplansdata.findIndex(item => item.commissionplan == v.commissionplan) === i);
        this.commplansdata = this.commplansdata.sort((a, b) => (a.commissionplan < b.commissionplan) ? -1 : 1);

// sort safely
// this.commplansdata = this.commplansdata.sort((a: any, b: any) =>
//   String(a.commissionplan).localeCompare(String(b.commissionplan))
// );

        //console.log(JSON.stringify(this.commplansdata.length));

        this.commplansdataSup = JSON.parse(JSON.stringify(data));
        this.commplansdataRep = JSON.parse(JSON.stringify(data));
        this.commplansdatafilter = JSON.parse(JSON.stringify(data));

        if (this.commplansdata.length > 0) {
          for (let searchdata of this.commplansdata) {
            this.salesChannel = searchdata.sales_channel;
            this.comm_plan_id = searchdata.comm_plan_id;
            this.effective_date = searchdata.effective_date;
          }

          this.showImage(this.commplansdata[0].comm_img_str, this.commplansdata[0].commissionplan);

          this.scempid1 = this.commplansdata[0].scempid;
          this.comm_plan_id = this.commplansdata[0].comm_plan_id;
          this.homeModelDefault.scempid = this.comm_plan_id;
          this.salesChannel = this.commplansdata[0].sales_channel;
          this.effective_date = this.commplansdata[0].effective_date;

          if (localStorage.getItem('CURRENT_USERROLE_SESSION') !== "Sales Representative") {
            console.log("Inside IF Supervisor");
            this.commplansdataSup = (this.commplansdataSup ?? []).filter((comm: any) => comm && comm.user_role === 'Supervisor');

            if (this.commplansdataSup.length > 0) {
              this.comm_plan_id = this.commplansdataSup[0].comm_plan_id;
              this.showImage(this.commplansdataSup[0].comm_img_str, this.commplansdataSup[0].commissionplan);
              this.homeModelDefault.scempid = this.comm_plan_id;
              this.scempid1 = this.commplansdataSup[0].scempid;
            } else {
              // fallback to first available plan (or just skip supervisor-specific image)
              this.comm_plan_id = this.commplansdata[0].comm_plan_id;
            }
          }

          this.getCalrunidsList();
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        //console.log(errorResponse.status);
        if (errorResponse.status === 403) {
          //this.eventBusService.emit(new EventData('logout', null));
        }

      });
  }

  getCalrunidsList() {
    console.log("getCalrunidsList() called");

    localStorage.setItem('CURRENT_SC_EMP_ID_SESSION', this.scempid1);
    //console.log(localStorage.getItem('CURRENT_SC_EMP_ID_SESSION'));

    // console.log(this.scempid1);

    this.homeService.getCalrunidsList(this.scempid1)
      .subscribe((data: any) => {
        this.calrunidsdata = data;
        // console.log(this.calrunidsdata);
        if (this.calrunidsdata.length > 0) {
          this.calrunidsdata = this.calrunidsdata.filter((v, i) => this.calrunidsdata.findIndex(item => item.calyear == v.calyear) === i);
          this.calrunidsdata = this.calrunidsdata.sort((a, b) => (b.calyear < a.calyear) ? -1 : 1);
          // console.log(this.calrunidsdata);

          // console.log(this.calrunidsdata[0].calyear);
          this.homeModelDefault.calyear = this.calrunidsdata[0].calyear;
          // console.log(this.homeModelDefault.calyear);

          this.getCommRevList();
        }
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  getCommRevList() {
    console.log("getCommRevList() called");
    localStorage.setItem('level', "0");

    if (!this.calyear) {

      this.calyear = this.homeModelDefault.calyear;
    }
    if (!this.scempid) {
      this.scempid = this.homeModelDefault.scempid;
    }

    this.commplansdatafilter = this.commplansdata;
    this.commplansdatafilter = this.commplansdatafilter.filter(comm => comm.scempid.startsWith(this.scempid1));
    this.effective_date = this.commplansdatafilter[0].effective_date;
    localStorage.setItem('CURRENT_SC_EMP_ID_SESSION', this.scempid1);

    localStorage.setItem('calyear', this.calyear);
    localStorage.setItem('scempid1', this.scempid1);
    localStorage.setItem('comm_plan_id', this.comm_plan_id);

    this.homeService.getCommRevList(this.calyear, this.scempid1, this.comm_plan_id)
      .subscribe((data: any) => {
        // console.log(JSON.stringify(data));
        // console.log(this.commplansdata[0].commissionplan);
        if (data.length > 0) {

          this.homeModelDefault.calyear = Number(this.calyear);
          this.commrevdata = data;
          console.log(this.commplansdata[0].sales_channel);
          if (this.commplansdata[0].sales_channel === "Web Assist") {
            this.commrevdata = this.commrevdata.filter(item => item.commyear > Number(202410));
          } else if (this.commplansdata[0].sales_channel === "Inbound") {
            this.commrevdata = this.commrevdata.filter(item => item.commyear > Number(202506));
          } else if (this.commplansdata[0].sales_channel === "Retail") {
            this.commrevdata = this.commrevdata.filter(item => item.commyear > Number(202509));
          }

         
          this.commrevdatasearch = JSON.parse(JSON.stringify(data));
          this.loadChartDefault(this.loginEmployeeId);

          for (let searchdata of this.commrevdata) {
            this.complanid = searchdata.comm_plan_id;
            this.caltype = searchdata.calendar_type;
            this.calrunid = searchdata.commyear;
            this.edate = searchdata.edate;
            this.validToDate = searchdata.valid_to_dt;
          }

          localStorage.setItem('SESSION_EFFDATE', this.edate);
          localStorage.setItem('commplan', this.complanid);
        } else {
          this.commrevdata = [];
        }
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  public getDisputeStatus(homeModel: HomeModel, url: string, pageName: string) {


    console.log("getDisputeStatus() Called");
    this.homeService.getDisputeStatus(homeModel.comm_plan_id, homeModel.commyear)
      .subscribe((data: any) => {
        this.disputeclosedata = data;
        // console.log(this.disputeclosedata);
        //console.log(this.disputeclosedata[0].dispute_close_dt);
        // console.log(this.disputeclosedata.length);

        if (this.disputeclosedata.length > 0) {
          if (this.disputeclosedata[0].dispute_close_dt) {
            let d = new Date();
            let d1 = new Date(this.disputeclosedata[0].dispute_close_dt);
            var g1 = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            console.log(g1);
            var g2 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
            console.log(g2);

            if (g1.getTime() < g2.getTime()) {
              console.log("g1 is lesser than g2");
              localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
            } else if (g1.getTime() > g2.getTime()) {
              console.log("g1 is greater than g2");
              localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'notvalid');
            } else {
              console.log("both are equal");
              localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
            }
          } else {
            localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
          }
        } else {
          localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
        }

        console.log(localStorage.getItem('SESSION_DISPUTE_CLOSE_STATUS'));

        this.redirectCommSumm(homeModel, url, pageName);

      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  public getDisputeStatus1(homeModel: HomeModel, url: string, pageName: string) {
    console.log("getDisputeStatus1() Called");
    this.homeService.getDisputeStatus(homeModel.comm_plan_id, homeModel.commyear)
      .subscribe((data: any) => {
        ReviewCommissionsService.persistDisputeCloseStatus(data);
        this.redirectCommSumm1(homeModel, url, pageName);
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

public redirectCommSumm1(homeModel: HomeModel, url: string, pageName: string) {
    const filterValue = this.globalService._normalizeValue(String(homeModel.commyear));
    this.commrevdatasearch = this.commrevdatasearch.filter(comm =>
      this.globalService._normalizeValue(comm.commyear.toString()).startsWith(filterValue));
    this.commrevdatasearch = this.commrevdatasearch.filter((v, i) =>
      this.commrevdatasearch.findIndex(item => item.valid_from_dt == v.valid_from_dt) === i);

    const selectedRow = this.commrevdatasearch[0] ?? homeModel;
    const pageType = pageName === 'ListUsersByCustomer' ? 'By Customer' : 'By KPI';
    const commissionPlanLabel = this.commplansdatafilter?.[0]?.commissionplan
      || selectedRow.commissionplan
      || '';
    const headerInfo = commissionPlanLabel
      ? `${pageType} - ${commissionPlanLabel}`
      : pageType;

    const reviewModel = new ReviewCommissionsModel();
    reviewModel.salesChannel = this.salesChannel ?? selectedRow.sales_channel;
    reviewModel.commissionPlanId = homeModel.comm_plan_id ? [homeModel.comm_plan_id] : null;
    reviewModel.calRunId = String(homeModel.commyear);
    reviewModel.validFromDt = ReviewCommissionsService.toDate(selectedRow.valid_from_dt) ?? undefined;
    reviewModel.validToDt = ReviewCommissionsService.toDate(selectedRow.valid_to_dt) ?? undefined;
    reviewModel.effectiveDate = ReviewCommissionsService.toDate(this.edate) ?? undefined;
    reviewModel.pageName = pageName;
    reviewModel.selectedCommPlanHeader = headerInfo;

    if (!ReviewCommissionsService.isAdminRole(localStorage.getItem('CURRENT_USERROLE_SESSION'))) {
      reviewModel.scEmpID = this.scempid1;
    }
    ReviewCommissionsService.applyRoleBasedSearchScope(reviewModel);

    this.reviewCommissionsService.prepareNewSearchSession(
      reviewModel,
      pageName,
      headerInfo,
      this.searchCriteriaSet
    );
    this.router.navigate(['/' + url], { queryParams: { page: pageName } });
  }


  public redirectCommSumm(homeModel: HomeModel, url: string, pageName: string) {

    console.log("homeModel = " + JSON.stringify(homeModel));
    // console.log("url = " + url);
    // console.log("pageName = " + pageName);

    console.log(homeModel.commyear);
    console.log(homeModel.comm_plan_id);

    // this.getDisputeStatus(homeModel.comm_plan_id,homeModel.commyear);

    this.commSummaryModel.commPlanId = this.complanid;
    this.commSummaryModel.calendarType = this.caltype;
    this.commSummaryModel.calRunId = homeModel.commyear.toString();
    // console.log(this.commSummaryModel.calRunId);
    this.commSummaryModel.salesChannel = this.salesChannel;
    this.commSummaryModel.extra_sc_emp_id = 0;
    this.commSummaryModel.sc_emp_id = this.scempid;

    // console.log(this.commrevdatasearch);

    const filterValue = this.globalService._normalizeValue(this.commSummaryModel.calRunId);
    this.commrevdatasearch = this.commrevdatasearch.filter(comm => this.globalService._normalizeValue(comm.commyear.toString()).startsWith(filterValue));
    this.commrevdatasearch = this.commrevdatasearch.filter((v, i) => this.commrevdatasearch.findIndex(item => item.valid_from_dt == v.valid_from_dt) === i);

    // console.log(this.commrevdatasearch);

    localStorage.setItem('validToDt', this.commrevdatasearch[0].valid_from_dt.toString());

    //console.log("homeModel = " + JSON.stringify(this.commSummaryModel));

    this.commissionSummaryService.commSummaryModel = this.commSummaryModel;
    this.commissionSummaryService.searchCriteriaSet = this.searchCriteriaSet;
    this.router.navigate(['/' + url], { queryParams: { page: pageName } });

  }

  loadChartDefault(scempid: string) {
    //console.log(this.commrevdata[0].commyear, this.commrevdata[0].scempid);
    this.finalChart(this.commrevdata[0].commyear, scempid);
  }

  loadChart(event: any, homeModel: HomeModel) {
    // console.log("homeModel = " + JSON.stringify(homeModel));
    this.finalChart(homeModel.commyear, this.loginEmployeeId);
  }

  finalChart(calrun: number, empid: string) {
    this.homeService.loadChart(calrun, empid)
      .subscribe((data: any) => {
        this.loadchartdata = data;
        // console.log(this.loadchartdata);

        var keys = Object.keys(this.loadchartdata);
        var keys1: any = "";
        for (let aaa of keys) {
          keys1 = keys1 + aaa.toString() + ",";
        }
        var val = Object.values(this.loadchartdata);
        var val1: any = "";
        for (let aaa of val) {
          val1 = val1 + aaa + ",";
        }
        this.chartLabels = keys;
        this.chartData = [{
          data: val,
        }];
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }



  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  redirectDocs() {
    let url: string;
    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {
      url = "emp-doc";
    } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor") {
      url = "my-docs";
    } else {
      url = "my-docs";
    }
    this.router.navigate(['/' + url]);
  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }


  showImage(comm_img: string, img_name: string) {
  if (!comm_img || comm_img === 'NO IMAGE') {
    this.imgStr = null;
    return;
  }

  // Set image only when valid
  this.imgStr = this._sanitizer.bypassSecurityTrustResourceUrl(
    'data:image/jpg;base64,' + encodeURI(comm_img)
  );
}


toggleShow(event: any) {

  this.comm_plan_id = event.currentTarget.value;

  if (this.comm_plan_id === "" || this.comm_plan_id === null) {
    this.imgStr = null; // reset image
    return;
  }

  this.calyear = "";
  this.commrevdata = [];

  this.scempid = this.comm_plan_id;

  // Filter commission plan
  this.commplansdataRep = this.commplansdata.filter(
    comm => comm.comm_plan_id === Number(this.comm_plan_id)
  );

  if (this.commplansdataRep.length > 0) {
    this.scempid1 = this.commplansdataRep[0].scempid;

    // Call showImage here (important)
    this.showImage(
  (this.commplansdataRep[0] as any).comm_img,
  (this.commplansdataRep[0] as any).img_name
);
  } else {
    this.imgStr = null;
  }

  this.getCalrunidsList();
}


toggleShow2(event: any) {

  if (event.currentTarget.value === "" || event.currentTarget.value === null) {
    return;
  }

  if (!this.scempid) {
    this.scempid = this.homeModelDefault.scempid;
  }

  this.calyear = event.currentTarget.value;
  this.getCommRevList();
}



}
